import { render, staticRenderFns } from "./dialogDuban.vue?vue&type=template&id=4461f420&scoped=true"
import script from "./dialogDuban.vue?vue&type=script&lang=js"
export * from "./dialogDuban.vue?vue&type=script&lang=js"
import style0 from "./dialogDuban.vue?vue&type=style&index=0&id=4461f420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4461f420",
  null
  
)

export default component.exports